import { ErrorState } from './ui';

export function ReadState({ loading, error, retry, label = 'Loading…' }: {
  loading: boolean; error: string; retry: () => void; label?: string;
}) {
  if (loading) return <p className="live-loading" role="status">{label}</p>;
  if (error) return <div className="live-error"><ErrorState message={error} retry={retry} /></div>;
  return null;
}
